
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';

export default function PromoteurRoute({ children }) {
  const { user, role, isLoading } = useAuth();

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Autoriser admin ET promoteur
  if (role !== "admin" && role !== "promoteur") {
    console.warn(
      "⛔ Accès refusé (admin ou promoteur uniquement), rôle détecté :",
      role
    );
    return <Navigate to="/" replace />;
  }

return <Outlet />;
}
